import {
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputProps as ChakraNumberInputProps,
  NumberInputStepper,
  InputGroup,
} from '@eigtech/ui-shared-dave'
import { FC, ReactNode } from 'react'
import { get, useController } from 'react-hook-form'
import { BaseProps, FormControl } from '../form-control'

export interface NumberInputControlProps extends BaseProps {
  /**
   * Chakra's NumberInputProps
   */
  numberInputProps?: ChakraNumberInputProps

  /**
   * Whether or not the stopper should be shownF
   */
  showStepper?: boolean

  /**
   * Optional children
   */
  children?: ReactNode
}

export const NumberInputControl: FC<NumberInputControlProps> = (props: NumberInputControlProps) => {
  const { name, control, label, showStepper = true, children, numberInputProps, ...rest } = props
  const {
    field,
    fieldState: { isTouched },
    formState: { isSubmitting, errors },
  } = useController({
    name,
    control,
    defaultValue: numberInputProps?.defaultValue || '',
  })
  const error = get(errors, name, '')
  const { ref, ...restField } = field

  return (
    <FormControl control={control} label={label} name={name} {...rest}>
      <InputGroup>
        =
        <NumberInput
          {...restField}
          id={name}
          isDisabled={isSubmitting}
          isInvalid={!!error && isTouched}
          {...numberInputProps}
          value={field.value ?? ''}
        >
          <NumberInputField ref={ref} name={name} />
          {showStepper && (
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          )}
          {children}
        </NumberInput>
        =
      </InputGroup>
    </FormControl>
  )
}

NumberInputControl.displayName = 'NumberInputControl'

export default NumberInputControl
